import {head, isNonEmpty, tail} from 'web-app/util/non-empty-array';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import type * as Types from '../types';

type SecondBillingPeriodByBillingType = ({
    monthlyBillingPeriods,
    weeklyBillingPeriods,
}: {
    monthlyBillingPeriods: null | Types.MonthlyPeriods;
    weeklyBillingPeriods: null | Types.WeeklyPeriods;
}) => {
    secondMonthlyPeriod: null | Types.Month;
    secondWeeklyPeriod: null | Types.Week;
};
export const secondBillingPeriodByBillingType: SecondBillingPeriodByBillingType = ({
    monthlyBillingPeriods,
    weeklyBillingPeriods,
}) => ({
    secondMonthlyPeriod: secondPeriod(monthlyBillingPeriods?.periods ?? null),
    secondWeeklyPeriod: secondPeriod(weeklyBillingPeriods?.periods ?? null),
});

const filterOutCustomPeriod = <T extends Types.Month | Types.Week>(periods: Array<T | Types.CustomPeriod>) => {
    return periods.filter<T>((period): period is T => period.type !== 'custom');
};

const secondPeriod = <T extends Types.Month | Types.Week>(periods: null | Array<T | Types.CustomPeriod>) => {
    if (!hasValue(periods)) {
        return null;
    }

    const periodsWithoutCustom = filterOutCustomPeriod<T>(periods);
    if (!isNonEmpty(periodsWithoutCustom)) {
        return null;
    }
    const periodsWithoutCustomTail = tail(periodsWithoutCustom);
    if (!isNonEmpty(periodsWithoutCustomTail)) {
        return null;
    }

    return head(periodsWithoutCustomTail);
};
